import Vue from 'vue'
import Router from 'vue-router'

/* Layout */
import Layout from '../views/layout/layout'
import myHome from '../views/home/my_home'
import appLayout from '../views/layout/appLayout'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    name: 'auto',
    redirect: '/web/home',
    // component: () => import('@/views/home/home')
  },

  // ********************************** 登录注册相关 start ********************************
  {
    path: '/login',
    component: () => import('@/views/login/login')
  },
  {
    path: '/web/home/image/:certificate_type',
    name: 'certificate',
    component: () => import('@/views/home/certificate_detail')
  },

  // ********************************** 登录注册相关 end ********************************
  // ********************************** 首页相关 start **********************************
  {
    path: '/web/home',
    component: Layout,
    redirect: '/web/index',
    name: 'home',
    meta: {
      title: '',
    },
    children:[
      {
        path: '/web/index',
        name: 'index',
        component: () => import('@/views/home/home'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/web/index/information_details',
        name: 'informationDetails',
        component: () => import('@/views/home_page/information_details'),
      },
      {
        path: '/web/index/dredge_vip',
        name: 'dredgeVip',
        component: () => import('@/views/home_page/dredge_vip'),
      },
      {
        path: '/web/index/search_result',
        name: 'searchResult',
        component: () => import('@/views/home_page/search_result'),
      },

    ]
  },
  // ********************************** 首页相关 end ************************************
  // ********************************** 直播相关相关 start **********************************
  {
    path: '/web/live',
    component: Layout,
    redirect: '/web/live',
    name: 'liveHome',
    meta: {
      title: '',
    },
    children:[
      {
        path: '/web/live',
        name: 'liveHome',
        component: () => import('@/views/home/live'),
        meta: {
          keepAlive: true
        }
      },

    ]
  },
  {
    path: '/web/live/detail',
    name: 'liveDetail',
    meta: {
      title: '',
    },
    component: () => import('@/views/live/live_detail_home')
  },
  // ********************************** 直播相关相关 end **********************************
  // ********************************** 发现相关 start **********************************

  {
    path: '/web/discover',
    component: Layout,
    redirect: '/web/discover',
    name: 'discoverHome',
    meta: {
      title: '',
    },
    children:[
      {
        path: '/web/discover',
        name: 'discoverHome',
        component: () => import('@/views/home/discover'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/web/discover/activity_detail',
        name: 'activityDetail',
        component: () => import('@/views/discover/activity_detail'),
        // meta: {
        //   keepAlive: true
        // }
      },

    ]
  },


  // ********************************** 发现相关 end **********************************


  // ********************************** 我的相关 start **********************************

  {
    path: '/web/my',
    name: 'myHomes',
    component: Layout,
    redirect: '/web/my/personal_data',
    name: 'myHome',
    meta: {
      title: '我的',
    },
    children:[
      {
        path: 'personal',
        name: 'myPersonal',
        meta: {
          title: '个人中心',
          keepAlive: true
        },
        component: myHome,
        children: [
          {
            path: '/web/my/message_center',
            name: 'messageCenter',
            meta: {
              title: '消息中心'
            },
            component: () => import('@/views/my/message_center'),
          },
          {
            path: '/web/my/message_detail',
            name: 'messageDetail',
            meta: {
              title: '消息详情'
            },
            component: () => import('@/views/my/message_detail'),
          },

          {
            path: '/web/my/payment_vip',
            name: 'paymentVip',
            meta: {
              title: '开通会员'
            },
            component: () => import('@/views/my/payment_vip'),
          },
          {
            path: '/web/my/personal_data',
            name: 'personalData',
            meta: {
              title: '个人资料'
            },
            component: () => import('@/views/my/personal_data'),
          },
          {
            path: '/web/my/wallet',
            name: 'myWallet',
            meta: {
              title: '钱包'
            },
            component: () => import('@/views/my/wallet'),
          },
          {
            path: '/web/my/collect',
            name: 'myCollect',
            meta: {
              title: '收藏'
            },
            component: () => import('@/views/my/collect'),
          },
          {
            path: '/web/my/bought_live',
            name: 'boughtLive',
            meta: {
              title: '已购'
            },
            component: () => import('@/views/my/bought_live'),
          },
          {
            path: '/web/my/watch_record',
            name: 'watchRecord',
            meta: {
              title: '观看记录'
            },
            component: () => import('@/views/my/watch_record'),
          },
          {
            path: '/web/my/registration_record',
            name: 'registrationRecord',
            meta: {
              title: '报名记录'
            },
            component: () => import('@/views/my/registration_record'),
          },
          {
            path: '/web/my/registration_record_detail',
            name: 'registrationRecordDetail"',
            meta: {
              title: '报名记录详情'
            },
            component: () => import('@/views/my/registration_record_detail'),
          },

        ],
        // component: () => import('@/views/home/my_home'),
      },
      {
        path: 'system',
        name: 'system',
        meta: {
          title: '系统',
          keepAlive: true
        },
        component: myHome,
        children: [
          {
            path: '/web/my/setting',
            name: 'setting',
            meta: {
              title: '基础设置'
            },
            component: () => import('@/views/my/setting'),
          },
          {
            path: '/web/my/feedback',
            name: 'feedback',
            meta: {
              title: '意见反馈'
            },
            component: () => import('@/views/my/feedback'),
          },
          {
            path: '/web/my/usual_question',
            name: 'usualQuestion',
            meta: {
              title: '常见问题'
            },
            component: () => import('@/views/my/usual_question'),
          },
          {
            path: '/web/my/usual_question_detail',
            name: 'usualQuestionDetail',
            meta: {
              title: '常见问题详情'
            },
            component: () => import('@/views/my/usual_question_detail'),
          },
          {
            path: '/web/my/about_us',
            name: 'aboutUs',
            meta: {
              title: '关于我们'
            },
            component: () => import('@/views/my/about_us'),
          },
        ]
      }

    ]
  },

  // ********************************** 我的相关 end **********************************


  // *****************************app分享 start************************************

  {
    path: '/web/app',
    name: 'appShare',
    component: appLayout,
    redirect: '/web/app/share',
    meta: {
      title: '分享'
    },
    children: [{
        path: '/web/app/share',
        name: 'appShareContent',
        component: () => import('@/views/app_share/app')
      },
      {
        path: '/web/app/share/information',
        name: 'appShareInformation',
        component: () => import('@/views/app_share/information')
      },
      {
        path: '/web/app/share/live',
        name: 'appShareLive',
        component: () => import('@/views/app_share/live_detail')
      },
      {
        path: '/web/app/share/text_image',
        name: 'appShareTextImage',
        component: () => import('@/views/app_share/text_image')
      },

    ]
  }
  // *****************************app分享 end************************************


  
  // {
  //   path: '/home',
  //   component: Layout,
  //   redirect: '/home/video_list',
  //   name: 'VideoLiveList',
  //   meta: {
  //     title: '直播列表',
  //   },
  //   children: [{
  //     path: 'video_list',
  //     name: 'videoList',
  //     component: () => import('@/views/video_live/video_live_list')
  //   }]
  // }
]

const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({
    y: 0
  }),

  routes: constantRoutes
})

const router = createRouter()

const CHUNK_RELOAD_KEY = 'chunk_load_reload'
const CHUNK_RELOAD_WINDOW = 5 * 60 * 1000
const CHUNK_RELOAD_MAX = 2

// 发版后旧页面引用的异步 chunk 已失效，加载失败时自动刷新页面获取最新资源。
// 时间窗内限制刷新次数，超限后不再刷新，防止异常情况下无限刷新
router.onError((error) => {
  const message = (error && error.message) || ''
  const isChunkLoadFailed = /loading (css )?chunk [\d]+ failed|chunkloaderror/i.test(message)
  if (!isChunkLoadFailed) return

  const now = Date.now()
  let records = []
  try {
    records = JSON.parse(sessionStorage.getItem(CHUNK_RELOAD_KEY) || '[]')
  } catch (e) {
    records = []
  }
  records = records.filter((time) => now - time < CHUNK_RELOAD_WINDOW)
  if (records.length >= CHUNK_RELOAD_MAX) return

  records.push(now)
  try {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, JSON.stringify(records))
    window.location.reload()
  } catch (e) {
    // storage 不可用时无法跨刷新持久化记录，放弃自动刷新以避免无限刷新
  }
})

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router


// WEBPACK FOOTER //
// ./src/router/index.js